var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ButtonComponent',_vm._g({staticClass:"shop-conditions-input",class:{ 'shop-conditions-input--empty': !this.conditions.length },attrs:{"icon":['fal', 'low-vision'],"label":_vm.label}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }